import React from 'react'
import { Dejargonator, TextBody } from '@ally/metronome-ui'
import styled from 'styled-components'
import {
  Dt,
  LightDejargBody,
  StyledDejargTrigger,
} from './DlComponents/StyledDlElements'

export const TopCardDdWrapper = styled.span`
  > span {
    margin-inline-start: 0;
  }
`

export const TopCardItem: React.FC<{ title: string; dejargContent?: string }> =
  ({ title, dejargContent, children }) => {
    return (
      <>
        <Dt size="xs">
          {dejargContent ? (
            <Dejargonator
              trigger={{
                variant: 'element',
                content: (
                  <StyledDejargTrigger>
                    <TextBody tag="span" size="xs" weight="bold">
                      {title}
                    </TextBody>
                  </StyledDejargTrigger>
                ),
                ariaLabel: title,
              }}
              body={
                <LightDejargBody tag="p" size="sm">
                  {dejargContent}
                </LightDejargBody>
              }
              ariaLabelPopover={dejargContent}
            />
          ) : (
            <TextBody tag="span" size="xs" weight="bold">
              {title}
            </TextBody>
          )}
        </Dt>
        <TopCardDdWrapper>{children}</TopCardDdWrapper>
      </>
    )
  }
